import { STATUS } from "../../constants/status";
import { AdministrativeUnit } from "./city";

export class Branch {
    _id: string = "";
    brand_id: string = "";
    name: string = "";
    phone: string = "";
    email: string = "";
    description: string = "";
    manager_id: string = "";
    manager_name: string = "";
    computer_count: number = 0;
    status: STATUS = STATUS.ACTIVE;
    street: string = "";
    created_at: string = "";
    updated_at: string = "";
    ward: AdministrativeUnit = new AdministrativeUnit();
    district: AdministrativeUnit = new AdministrativeUnit();
    city: AdministrativeUnit = new AdministrativeUnit();
    lat: number = 0;
    lng: number = 0;
    constructor(data?: Partial<Branch>) {
        Object.assign(this, data);
    }
}

